<template>
  <div class="uk-container uk-margin-large-top">
    <div v-if="loading">
      <p>Loading</p>
    </div>

    <h3>Choose Factoring Company</h3>

    <FilterableDropdown
      id="DropOffName"
      :options="billingCustomers"
      label="name"
      class="uk-form-width-large uk-align-center"
      :value="customerName"
      @input="setCustomer"
      @search-change="onBillingCustomerSearch"
      :components="{ OpenIndicator: null, Deselect: null }"
    ></FilterableDropdown>
    <button
      v-if="editingFactoringCompany"
      @click="saveFactoringCompany"
      class="uk-button uk-button-primary uk-margin-left uk-width-1-3"
    >
      Save
    </button>
    <button
      v-else
      @click="saveFactoringCompany"
      disabled
      class="uk-button uk-button-primary uk-margin-left uk-width-1-3"
    >
      Save
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import FactoringCompanyUserQuery from '@/gql/user/UserFactoringCompany.gql';

import Customers from '@/gql/customers/Customers.gql';
import SaveFactoringCompany from '@/gql/company/mutations/SaveFactoringCompany.gql';

import BillingCustomersQuery from '@/gql/customers/BillingCustomers.gql';
import ReceivingCustomersQuery from '@/gql/customers/ReceivingCustomers.gql';
import UIkit from 'uikit';

import FilterableDropdown from '../core/FilterableDropdown.vue';

export default defineComponent({
  data() {
    return {
      loading: false,
      customerName: undefined,
      billingCustomerNameQuery: '',
      receivingCustomerNameQuery: '',
      factoringCompany: undefined,
      editingFactoringCompany: false,
    };
  },
  components: { FilterableDropdown },
  methods: {
    setCustomer(customer) {
      const vm = (this as any);

      console.log(`setting customer ${JSON.stringify(customer)}`);
      vm.factoringCompany = customer;
      vm.customerName = customer.name;
      vm.editingFactoringCompany = true;
    },
    onBillingCustomerSearch(customerName) {
      const vm = (this as any);

      vm.billingCustomerNameQuery = customerName;
    },
    saveFactoringCompany() {
      const vm = (this as any);

      vm.$apollo
        .mutate({
          mutation: SaveFactoringCompany,

          variables: {
            factoringCompanyId: vm.factoringCompany.id,
          },
        })
        .then((data) => {
          console.log(data);
          UIkit.notification({
            message: 'Saved factoring company',
            status: 'success',
            timeout: 5000,
          });
          vm.editingFactoringCompany = false;
        })
        .catch((error) => {
          vm.message = null;
          console.error(error);
        });
    },
  },
  apollo: {
    user: {
      query: FactoringCompanyUserQuery,
      result(result) {
        const vm = (this as any);

        console.log('FACTORING COMPANY USER Q', result);
        if (!vm.customerName) {
          vm.customerName = result.data.user.company.factoringCompany.name;
        }
      },
    },
    billingCustomers: {
      query: BillingCustomersQuery,
      debounce: 100,
      variables() {
        // Use vue reactive properties here
        return {
          name: (this as any).billingCustomerNameQuery,
        };
      },
    },
    receivingCustomers: {
      query: ReceivingCustomersQuery,
      debounce: 100,
      variables() {
        // Use vue reactive properties here
        return {
          name: (this as any).receivingCustomerNameQuery,
        };
      },
    },
  },
});
</script>
>

<style></style>
